import * as React from 'react';
import { Link } from 'react-router-dom';
import { PageRoutes } from '../../root/Routes';

interface AuthenticationHeaderProps {
    message: {
        text: string,
        label: string
    };
}

export function AuthenticationFooter(props: AuthenticationHeaderProps): JSX.Element {
    const endpoint = window.location.pathname;

    return (
        <footer>
            <p>{props.message.text}</p>
            <Link to={chooseRedirect(endpoint)}>
                {props.message.label}
            </Link>
        </footer>
    );

    function chooseRedirect(endpointPath: string): string {
        switch (endpointPath) {
            case PageRoutes.Register:
                return PageRoutes.Login;
            case `/webportal${PageRoutes.Register}`:
                return PageRoutes.Login;
            case PageRoutes.Login:
                return PageRoutes.Register;
            case `/webportal${PageRoutes.Login}`:
                return PageRoutes.Register;
            case PageRoutes.PasswordStep:
                return PageRoutes.Login;
            case `/webportal${PageRoutes.PasswordStep}`:
                return PageRoutes.Login;
            case PageRoutes.CodeConfirmation:
                return PageRoutes.Login;
            case `/webportal${PageRoutes.CodeConfirmation}`:
                return PageRoutes.Login;
            case PageRoutes.ResetPassword:
                return PageRoutes.Register;
            case `/webportal${PageRoutes.ResetPassword}`:
                return PageRoutes.Register;
            case PageRoutes.ResetCodeExpired:
                return PageRoutes.Register;
            case `/webportal${PageRoutes.ResetCodeExpired}`:
                return PageRoutes.Register;
            case PageRoutes.CodeExpired:
                return PageRoutes.Register;
            case `/webportal${PageRoutes.CodeExpired}`:
                return PageRoutes.Register;
            default:
                return '';
        }
    }
}


// WEBPACK FOOTER //
// ./src/webportal/components/common/authenticationCardComponents/AuthenticationFooter.tsx